import styled from "styled-components";

export const ButtonContainer = styled.button`
  &.button {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 19px;
    color: white;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    font-family: "latomedium";
    cursor: pointer;
    user-select: none;
    border: 1px solid transparent;
    background: #005586;
    border-radius: 4px;

    .green-order {
      background: linear-gradient(90deg, #55c416 1.12%, #367910 100%);
      border: none;
      color: #fff;
    }

    &:disabled,
    &[disabled],
    &.inactive {
      cursor: default;
      opacity: 0.4;
    }

    &.primary {
      background-color: #9d9d9d;
    }
    &.no-style {
      border: 0;
      background-color: transparent;
      color: inherit;
      padding: initial;
      -webkit-appearance: none;
    }
    &:active,
    &:focus {
      outline: none;
    }
    &:hover {
      // opacity: 0.95;
    }
    &.withWhiteBorder {
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      border: solid 2px #ffffff;
      color: #ffffff;
    }
    &.with-blue-border {
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      border: solid 1px #1c5bae;
      color: #1c5bae;
    }
    &.no-border {
      border: 0 !important;
    }
  }
`;
